import { c as _c } from "react/compiler-runtime";
import { cn } from '@module/lib/utils';
function BroadcastUserList(t0) {
  const $ = _c(5);
  const {
    children,
    className
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = cn("-mr-[20px] flex flex-wrap", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== children || $[3] !== t1) {
    t2 = <ul className={t1}>{children}</ul>;
    $[2] = children;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
}
export default BroadcastUserList;